import { getSetting, useSetting } from '@app/hooks/user/mysetting.tsx';
import { SETTING_TYPE_SYSTEM } from '@app/constants/SETTING.tsx';
import { useFetcherPublic } from '@app/hooks/fetcher.tsx';

export const CurrencySymbol = () => {
  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const currency = getSetting(setting, "CURRENCY", "USD");
  const { data: currencyData } = useFetcherPublic("/system/currency");


  const exchangeRate = currencyData?.result?.result?.find(rate => rate.code === currency);


  return exchangeRate?.symbol;
}